import roleApi from "@/api/role";

export default {
  actions: {
    async fetchList({ commit }) {
      const list = await roleApi.list();

      commit("setList", list);
    },
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
  },
  namespaced: true,
  state: {
    list: [],
  },
};
